import React, { useEffect, useState } from 'react';
import './comingsoon.css';
import logo from '../assets/images/MedTinz.png';


const Comingsoon = () => {
    // État pour le compte à rebours
    const [time, setTime] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        // Cible la date de lancement
        const targetDate = new Date("03/27/2025 10:00:00 AM").getTime();

        // Met à jour le compte à rebours toutes les secondes
        const interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                clearInterval(interval);
                setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            } else {
                setTime({
                    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000),
                });
            }
        }, 1000);

        // Nettoie l'intervalle à la fin
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="coming-soon ">
            <div className="content-wrap ">
                <div className="logo-box">
                    <img src={logo} alt="Logo" />
                </div>
                <div className="cta-box">
                    <h1>Nous serons <span className="highlight">bientôt de retour !</span></h1>
                    <p>Nous profitons de cette période pour donner un coup de jeune à notre site web !</p>
                </div>
                {/* Formulaire commenté */}
                {/* <form action="" className="newsletter" name="newsletter" method="post">
        <input type="email" className="form-field" name="email" placeholder="Your Email" />
        <button type="submit" className="btn-main">Notify me!</button>
      </form> */}
                <div className="countdown">
                    <p className="timer-cta">Nous lancerons notre site internet en</p>
                    <ul className="timer">
                        <li>
                            <div className="time-box">
                                <span className="time">{time.days}</span> <span className="time-txt">Jours</span>
                            </div>
                        </li>
                        <li>
                            <div className="time-box">
                                <span className="time">{time.hours}</span> <span className="time-txt">Heures</span>
                            </div>
                        </li>
                        <li>
                            <div className="time-box">
                                <span className="time">{time.minutes}</span> <span className="time-txt">Minutes</span>
                            </div>
                        </li>
                        <li>
                            <div className="time-box">
                                <span className="time">{time.seconds}</span> <span className="time-txt">Secondes</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    );
};

export default Comingsoon;
